import {
  COLUMN_FIELDS,
  COLUMN_LABELS,
  type ColumnField,
  type ColumnVisibility,
} from './preset-defaults'

interface ColumnChecklistProps {
  values: ColumnVisibility
  defaults: ColumnVisibility
  onChange: (field: ColumnField, checked: boolean) => void
  onReset: () => void
}

export function ColumnChecklist({ values, defaults, onChange, onReset }: ColumnChecklistProps) {
  const hasDiff = COLUMN_FIELDS.some((f) => values[f] !== defaults[f])

  return (
    <div className="mt-4 border-t border-gray-200 pt-4">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-[13px] font-semibold text-gray-500">คอลัมน์ที่แสดง (Visible Columns)</span>
        {hasDiff && (
          <button
            type="button"
            onClick={onReset}
            className="text-[11px] font-medium text-blue-600 transition-colors hover:text-blue-700"
          >
            รีเซ็ต
          </button>
        )}
      </div>
      <div className="flex flex-col gap-0.5">
        {COLUMN_FIELDS.map((field) => (
          <label
            key={field}
            className="flex cursor-pointer items-center gap-2.5 rounded-xs px-1 py-2 transition-colors hover:bg-gray-50"
          >
            <input
              type="checkbox"
              checked={values[field]}
              onChange={(e) => onChange(field, e.target.checked)}
              className="size-4 rounded-md border-gray-300 accent-blue-600"
            />
            <span className="text-[13px] text-gray-700">{COLUMN_LABELS[field]}</span>
          </label>
        ))}
      </div>
    </div>
  )
}
